import { defineMessages } from 'dibs-react-intl';

export default defineMessages({
    cardHolderName: {
        defaultMessage: 'Please enter a name.',
        id: 'du.dibs-credit-card-validator.creditCardHolderName',
    },
    required: {
        defaultMessage: 'Required field',
        id: 'du.dibs-credit-card-validator.required',
    },
    specialCharactersShort: {
        defaultMessage: 'No special characters',
        id: 'du.dibs-credit-card-validator.specialCharactersShort',
    },
    creditCardNumber: {
        defaultMessage: 'Please enter a valid credit card number',
        id: 'du.dibs-credit-card-validator.creditCardNumber',
    },
    'creditCardTypeNumber.visa': {
        defaultMessage: 'Please enter a valid Visa card number',
        id: 'du.dibs-credit-card-validator.creditCardTypeNumber.visa',
    },
    'creditCardTypeNumber.visaelectron': {
        defaultMessage: 'Please enter a valid Visa card number',
        id: 'du.dibs-credit-card-validator.creditCardTypeNumber.visaelectron',
    },
    'creditCardTypeNumber.mastercard': {
        defaultMessage: 'Please enter a valid Mastercard card number',
        id: 'du.dibs-credit-card-validator.creditCardTypeNumber.mastercard',
    },
    'creditCardTypeNumber.discover': {
        defaultMessage: 'Please enter a valid Discover card number',
        id: 'du.dibs-credit-card-validator.creditCardTypeNumber.discover',
    },
    'creditCardTypeNumber.amex': {
        defaultMessage: 'Please enter a valid American Express card number',
        id: 'du.dibs-credit-card-validator.creditCardTypeNumber.amex',
    },
    notSupportedCreditCard: {
        defaultMessage: 'We accept American Express, Visa, MasterCard and Discover',
        id: 'du.dibs-credit-card-validator.notSupportedCreditCard',
    },
    securityCode: {
        defaultMessage: 'Please enter a valid security code.',
        id: 'du.dibs-credit-card-validator.securityCode',
    },
    cardExpiry: {
        defaultMessage: 'Please enter a valid expiration date.',
        id: 'du.dibs-credit-card-validator.expiration',
    },
});
